import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CereriComponent } from './cereri.component';
import { MaterialModule } from 'src/app/material.module';
import { DataTablesModule } from 'angular-datatables';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from 'src/app/utils/pipes/pipes.module';
import { CereriDetaliiComponent } from './cereri-detalii/cereri-detalii.component';
import { SubsemnatComponent } from './cereri-detalii/subsemnat/subsemnat.component';
import { MesagerieComponent } from './cereri-detalii/mesagerie/mesagerie.component';
import { CerereDetaliiSabloaneComponent } from './cereri-detalii/sabloane/cerere-detalii-sabloane.component';
import { ActualizareCerereComponent } from './cereri-detalii/actualizare-cerere/actualizare-cerere.component';
import { ActiuniCerereCardComponent } from './cereri-detalii/actiuni-cerere-card/actiuni-cerere-card.component';
import { AddProgramareComponent } from './add-programare/add-programare.component';
import { IstoricCerereComponent } from './cereri-detalii/istoric-cerere/istoric-cerere.component';
import { ModalInchidereLucrareComponent } from './cereri-detalii/modal-inchidere-lucrare/modal-inchidere-lucrare.component';
import { EditSubsemnatComponent } from './cereri-detalii/subsemnat/edit-subsemnat/edit-subsemnat.component';
import { EditProgramareConfigComponent } from './cereri-detalii/subsemnat/edit-programare-config/edit-programare-config.component';
import { RescheduleProgramareComponent } from './cereri-detalii/subsemnat/reschedule-programare/reschedule-programare.component';
import { IstoricProgramariComponent } from './cereri-detalii/istoric-programari/istoric-programari.component';


@NgModule({
    declarations: [
        CereriComponent,
        CereriDetaliiComponent,
        SubsemnatComponent,
        MesagerieComponent,
        CerereDetaliiSabloaneComponent,
        ActualizareCerereComponent,
        ActiuniCerereCardComponent,
        AddProgramareComponent,
        IstoricCerereComponent,
        ModalInchidereLucrareComponent,
        EditSubsemnatComponent,
        EditProgramareConfigComponent,
        RescheduleProgramareComponent,
        IstoricProgramariComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        DataTablesModule,
        PipesModule
    ],
    exports: [CereriComponent],
})
export class CereriModule { }
